export const articleData: Record<string, {
  id: string;
  title: string;
  subtitle: string;
  category: string;
  categorySlug: string;
  cover: string;
  rating: number;
  episodes: number;
  status: string;
  updateDate: string;
  views: number;
  content: string;
  cast: { name: string; role: string; avatar: string }[];
  staff: { name: string; role: string }[];
  relatedArticles: { id: string; title: string; cover: string }[];
}> = {
  'nagihikari-s1': {
    id: 'nagihikari-s1',
    title: '凪光 第一季',
    subtitle: '风与光的少年，命运交织的奇幻冒险正式启程',
    category: '动画番剧',
    categorySlug: 'anime',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20anime%20banner%20art%20of%20a%20young%20hero%20with%20wind%20powers%20standing%20on%20a%20cliff%20at%20sunrise%2C%20flowing%20green%20cape%2C%20ocean%20below%2C%20warm%20golden%20light%2C%20Japanese%20animation%20cinematic%20quality&width=1600&height=700&seq=nagi-article-s1&orientation=landscape',
    rating: 9.6,
    episodes: 24,
    status: '已完结',
    updateDate: '2025-03-15',
    views: 1580000,
    content: `<h2>剧情简介</h2>
<p>在平凡的沿海小镇「潮鸣町」，17岁高中生朝凪过着普通而平静的生活。直到那年夏天的一场暴风雨中，他意外发现自己拥有操控风的能力——这是远古「风之一族」的血脉觉醒。</p>
<p>与此同时，一位名为「光」的神秘少女从海中出现。她来自深海王国「苍渊」，是为了寻找传说中的「风之继承者」而来。原来在千年前，风之一族与海之一族曾有过生死盟约，而如今黑暗势力「影渊」正在苏醒，企图吞噬两个世界的和平。</p>
<p>凪与光的相遇，不仅开启了跨越海陆的宏大冒险，也揭开了一段被尘封千年的宿命羁绊。在伙伴们的陪伴下，凪逐渐掌握了风之力的真正含义——不是破坏，而是守护。</p>

<h2>故事看点</h2>
<p>《凪光》以其精美的画面、动人心弦的音乐和细腻的人物刻画，迅速成为近年来最受瞩目的原创动画之一。第一季以「风之觉醒」为主线，讲述了凪从普通少年成长为风之继承者的完整历程，每一话都充满了紧张的战斗场面与温暖的日常片段交织。</p>
<p>作品巧妙地将日本传统神话元素与现代青春叙事结合，创造出独特的世界观。风、海、火、地——四大元素的力量体系构建严谨而富有想象力，为后续剧情埋下了大量伏笔。</p>`,
    cast: [
      { name: '松本健一', role: '朝凪（主角）', avatar: 'https://readdy.ai/api/search-image?query=Professional%20anime%20voice%20actor%20portrait%2C%20Japanese%20male%2C%20friendly%20smile%2C%20studio%20lighting%2C%20clean%20background&width=200&height=200&seq=nagi-cast-01&orientation=squarish' },
      { name: '佐藤美咲', role: '光（女主角）', avatar: 'https://readdy.ai/api/search-image?query=Professional%20anime%20voice%20actress%20portrait%2C%20Japanese%20female%2C%20gentle%20expression%2C%20studio%20lighting%2C%20clean%20background&width=200&height=200&seq=nagi-cast-02&orientation=squarish' },
      { name: '田中翔太', role: '炎真（对手）', avatar: 'https://readdy.ai/api/search-image?query=Professional%20anime%20voice%20actor%20portrait%2C%20Japanese%20male%2C%20intense%20look%2C%20studio%20lighting%2C%20clean%20background&width=200&height=200&seq=nagi-cast-03&orientation=squarish' },
      { name: '高桥花音', role: '风花（妹妹）', avatar: 'https://readdy.ai/api/search-image?query=Professional%20anime%20voice%20actress%20portrait%2C%20Japanese%20female%2C%20cheerful%20smile%2C%20studio%20lighting%2C%20clean%20background&width=200&height=200&seq=nagi-cast-04&orientation=squarish' },
    ],
    staff: [
      { name: '山田太郎', role: '原作·系列构成' },
      { name: '中村花子', role: '导演' },
      { name: '小林大輔', role: '角色设计' },
      { name: '加藤勇気', role: '音乐制作' },
      { name: '伊藤恵美', role: '美术监督' },
    ],
    relatedArticles: [
      { id: 'nagihikari-s2', title: '凪光 第二季：深海之章', cover: 'https://readdy.ai/api/search-image?query=Anime%20visual%20of%20a%20female%20character%20with%20water%20powers%20in%20an%20underwater%20palace%2C%20flowing%20blue%20hair%2C%20fantasy%20anime%20art%20style&width=800&height=450&seq=nagi-rel-01&orientation=landscape' },
      { id: 'nagihikari-movie', title: '凪光 剧场版：永恒之约', cover: 'https://readdy.ai/api/search-image?query=Epic%20anime%20movie%20poster%20two%20characters%20under%20starlit%20sky%2C%20cherry%20blossoms%2C%20cinematic%20style&width=800&height=450&seq=nagi-rel-02&orientation=landscape' },
      { id: 'nagihikari-ova1', title: '凪光 OVA：夏日的回忆', cover: 'https://readdy.ai/api/search-image?query=Anime%20summer%20festival%20scene%2C%20fireworks%2C%20yukata%2C%20lanterns%2C%20warm%20nostalgic%20atmosphere&width=800&height=450&seq=nagi-rel-03&orientation=landscape' },
    ],
  },
  'nagihikari-s2': {
    id: 'nagihikari-s2',
    title: '凪光 第二季：深海之章',
    subtitle: '深海王国之谜揭晓，全新的冒险在蔚蓝深处展开',
    category: '动画番剧',
    categorySlug: 'anime',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20anime%20banner%20of%20an%20underwater%20kingdom%2C%20crystal%20palace%2C%20glowing%20coral%2C%20female%20protagonist%20with%20blue%20hair%2C%20majestic%20atmosphere%2C%20Japanese%20animation%20style&width=1600&height=700&seq=nagi-article-s2&orientation=landscape',
    rating: 9.8,
    episodes: 24,
    status: '更新至第22话',
    updateDate: '2026-08-10',
    views: 2320000,
    content: `<h2>剧情简介</h2>
<p>第一季结尾，凪成功觉醒了风之力的完整形态，但影渊的威胁远未结束。在第二季中，故事转向海洋——光的故乡「苍渊」深海王国。</p>
<p>深海王国曾经是七海中最繁荣的文明，但在影渊的侵蚀下面临灭顶之灾。光作为海之公主的继承者，必须回到深海，解开被封印的王族之力。而凪，作为风之继承者，义无反顾地踏入了这片未知的水下世界。</p>
<p>在深海中，他们遇到了新的盟友与敌人。龙之继承者炎真、地之守护者石丸、以及神秘的海妖一族……四大元素的命运开始交织，一场跨越海陆空的史诗之战即将拉开帷幕。</p>

<h2>故事看点</h2>
<p>第二季的制作水准在第一季基础上全面升级。水下场景的光影效果令人叹为观止，每一帧都如同一幅精美的画作。音乐方面请来了好莱坞级别的交响乐团录制原声，宏大而细腻。</p>
<p>角色关系在第二季中变得更加复杂和深刻。凪与光之间的羁绊、炎真与凪之间的宿命对决、以及各元素继承者之间的合作与矛盾，都将第二季推向了情感的高潮。</p>`,
    cast: [
      { name: '松本健一', role: '朝凪（主角）', avatar: 'https://readdy.ai/api/search-image?query=Professional%20anime%20voice%20actor%20portrait%2C%20Japanese%20male%2C%20friendly%20smile%2C%20studio%20lighting%2C%20clean%20background&width=200&height=200&seq=nagi-cast-01&orientation=squarish' },
      { name: '佐藤美咲', role: '光（女主角）', avatar: 'https://readdy.ai/api/search-image?query=Professional%20anime%20voice%20actress%20portrait%2C%20Japanese%20female%2C%20gentle%20expression%2C%20studio%20lighting%2C%20clean%20background&width=200&height=200&seq=nagi-cast-02&orientation=squarish' },
      { name: '田中翔太', role: '炎真（对手）', avatar: 'https://readdy.ai/api/search-image?query=Professional%20anime%20voice%20actor%20portrait%2C%20Japanese%20male%2C%20intense%20look%2C%20studio%20lighting%2C%20clean%20background&width=200&height=200&seq=nagi-cast-03&orientation=squarish' },
      { name: '鈴木涼子', role: '海妖女王', avatar: 'https://readdy.ai/api/search-image?query=Professional%20anime%20voice%20actress%20portrait%2C%20Japanese%20female%2C%20elegant%20expression%2C%20studio%20lighting%2C%20clean%20background&width=200&height=200&seq=nagi-cast-05&orientation=squarish' },
    ],
    staff: [
      { name: '山田太郎', role: '原作·系列构成' },
      { name: '中村花子', role: '导演' },
      { name: '小林大輔', role: '角色设计' },
      { name: '加藤勇気', role: '音乐制作' },
      { name: '渡辺健太郎', role: 'CG监督' },
    ],
    relatedArticles: [
      { id: 'nagihikari-s1', title: '凪光 第一季', cover: 'https://readdy.ai/api/search-image?query=Anime%20key%20visual%20young%20male%20protagonist%20with%20wind%20powers%2C%20warm%20autumn%20color%2C%20Japanese%20high%20school%20setting&width=800&height=450&seq=nagi-rel-04&orientation=landscape' },
      { id: 'nagihikari-movie', title: '凪光 剧场版：永恒之约', cover: 'https://readdy.ai/api/search-image?query=Epic%20anime%20movie%20poster%20two%20characters%20under%20starlit%20sky%2C%20cherry%20blossoms%2C%20cinematic%20style&width=800&height=450&seq=nagi-rel-02&orientation=landscape' },
      { id: 'nagihikari-character-guide', title: '凪光 角色完全指南', cover: 'https://readdy.ai/api/search-image?query=Anime%20character%20lineup%20art%20six%20diverse%20characters%20fantasy%20series%2C%20dynamic%20poses%2C%20clean%20anime%20style&width=800&height=450&seq=nagi-rel-05&orientation=landscape' },
    ],
  },
  'nagihikari-movie': {
    id: 'nagihikari-movie',
    title: '凪光 剧场版：永恒之约',
    subtitle: '跨越千年的约定，在星光之下迎来最终篇章',
    category: '剧场版',
    categorySlug: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20anime%20movie%20theatrical%20banner%20with%20two%20silhouettes%20embracing%20under%20a%20starry%20sky%2C%20golden%20particles%20floating%2C%20ancient%20ruins%2C%20dramatic%20cinematic%20lighting%2C%20Japanese%20animation%20movie%20quality&width=1600&height=700&seq=nagi-article-movie&orientation=landscape',
    rating: 9.9,
    episodes: 1,
    status: '已上映',
    updateDate: '2026-06-01',
    views: 3850000,
    content: `<h2>剧情简介</h2>
<p>《凪光 剧场版：永恒之约》是连接第二季与第三季的重要篇章，讲述了一个独立而完整的故事。</p>
<p>故事发生在第二季结尾的数月后。凪与光发现了一个惊人的真相——千年前风之一族与海之一族的盟约并非简单的和平协议，而是一场为了封印远古邪神「虚無」的牺牲仪式。每一位继承者的力量，都是封印的一部分。</p>
<p>当虚無的封印开始松动，凪和光必须做出选择：是维持封印而牺牲自己的力量，还是打破封印正面迎战。在这个决定中，尘封千年的「永恒之约」终于揭开了它的真正含义——那是一份关于爱与牺牲的誓言。</p>

<h2>制作规模</h2>
<p>作为系列首部剧场版，《永恒之约》的制作规模达到了前所未有的高度。超过300名动画师历时18个月精心打造，画面质量堪称艺术品级别。音乐由东京爱乐乐团现场录制，主题曲由国际知名歌手演唱。</p>
<p>剧场版在日本上映首周即登顶票房冠军，全球累计票房突破150亿日元，成为当年最成功的动画电影之一。</p>`,
    cast: [
      { name: '松本健一', role: '朝凪（主角）', avatar: 'https://readdy.ai/api/search-image?query=Professional%20anime%20voice%20actor%20portrait%2C%20Japanese%20male%2C%20friendly%20smile%2C%20studio%20lighting%2C%20clean%20background&width=200&height=200&seq=nagi-cast-01&orientation=squarish' },
      { name: '佐藤美咲', role: '光（女主角）', avatar: 'https://readdy.ai/api/search-image?query=Professional%20anime%20voice%20actress%20portrait%2C%20Japanese%20female%2C%20gentle%20expression%2C%20studio%20lighting%2C%20clean%20background&width=200&height=200&seq=nagi-cast-02&orientation=squarish' },
      { name: '田中翔太', role: '炎真', avatar: 'https://readdy.ai/api/search-image?query=Professional%20anime%20voice%20actor%20portrait%2C%20Japanese%20male%2C%20intense%20look%2C%20studio%20lighting%2C%20clean%20background&width=200&height=200&seq=nagi-cast-03&orientation=squarish' },
    ],
    staff: [
      { name: '山田太郎', role: '原作·脚本' },
      { name: '中村花子', role: '导演' },
      { name: '小林大輔', role: '角色设计·总作画监督' },
      { name: '加藤勇気', role: '音乐制作' },
      { name: '渡辺健太郎', role: 'CG监督' },
      { name: '佐々木誠', role: '摄影监督' },
    ],
    relatedArticles: [
      { id: 'nagihikari-s1', title: '凪光 第一季', cover: 'https://readdy.ai/api/search-image?query=Anime%20key%20visual%20young%20male%20protagonist%20with%20wind%20powers%2C%20warm%20autumn%20color%2C%20Japanese%20high%20school%20setting&width=800&height=450&seq=nagi-rel-04&orientation=landscape' },
      { id: 'nagihikari-s2', title: '凪光 第二季：深海之章', cover: 'https://readdy.ai/api/search-image?query=Anime%20visual%20female%20character%20water%20powers%20underwater%20palace%2C%20fantasy%20anime%20art%20style&width=800&height=450&seq=nagi-rel-01&orientation=landscape' },
      { id: 'nagihikari-soundtrack', title: '凪光 原声音乐集', cover: 'https://readdy.ai/api/search-image?query=Beautiful%20music%20album%20cover%20art%20grand%20piano%20on%20cliff%2C%20ocean%20sunset%2C%20golden%20musical%20notes&width=800&height=450&seq=nagi-rel-06&orientation=landscape' },
    ],
  },
  'nagihikari-ova1': {
    id: 'nagihikari-ova1',
    title: '凪光 OVA：夏日的回忆',
    subtitle: '在烟火绽放的夜空下，珍藏属于青春的夏日诗篇',
    category: 'OVA特典',
    categorySlug: 'ova',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20OVA%20banner%20art%20summer%20festival%20night%20scene%2C%20characters%20in%20yukata%2C%20massive%20fireworks%20display%2C%20lanterns%2C%20warm%20golden%20lighting%2C%20nostalgic%20atmosphere%2C%20Japanese%20animation&width=1600&height=700&seq=nagi-article-ova&orientation=landscape',
    rating: 9.3,
    episodes: 2,
    status: '已完结',
    updateDate: '2025-08-20',
    views: 890000,
    content: `<h2>剧情简介</h2>
<p>暑假来临，潮鸣町迎来了一年一度的夏季祭典。凪与伙伴们决定一起参加这场盛大的节日活动。</p>
<p>在祭典的热闹氛围中，每个人都经历着各自的成长瞬间：凪在烟火大会上向光表达了自己的心意；炎真在捞金鱼摊位上展现出了意外的温柔一面；风花第一次穿上浴衣，感受到了作为「普通女孩」的快乐。</p>
<p>这部OVA以轻松温暖的日常为主线，穿插了许多令人会心一笑的小故事。虽然不涉及主线剧情的重大推进，但却是了解角色日常面貌和羁绊深度的绝佳篇章。</p>`,
    cast: [
      { name: '松本健一', role: '朝凪', avatar: 'https://readdy.ai/api/search-image?query=Professional%20anime%20voice%20actor%20portrait%2C%20Japanese%20male%2C%20friendly%20smile%2C%20studio%20lighting%2C%20clean%20background&width=200&height=200&seq=nagi-cast-01&orientation=squarish' },
      { name: '佐藤美咲', role: '光', avatar: 'https://readdy.ai/api/search-image?query=Professional%20anime%20voice%20actress%20portrait%2C%20Japanese%20female%2C%20gentle%20expression%2C%20studio%20lighting%2C%20clean%20background&width=200&height=200&seq=nagi-cast-02&orientation=squarish' },
      { name: '高橋花音', role: '風花', avatar: 'https://readdy.ai/api/search-image?query=Professional%20anime%20voice%20actress%20portrait%2C%20Japanese%20female%2C%20cheerful%20smile%2C%20studio%20lighting%2C%20clean%20background&width=200&height=200&seq=nagi-cast-04&orientation=squarish' },
    ],
    staff: [
      { name: '山田太郎', role: '原作' },
      { name: '中村花子', role: '导演' },
      { name: '小林大輔', role: '角色设计' },
    ],
    relatedArticles: [
      { id: 'nagihikari-s1', title: '凪光 第一季', cover: 'https://readdy.ai/api/search-image?width=800&height=450&seq=nagi-rel-04&orientation=landscape&query=Anime%20key%20visual%20young%20male%20protagonist%20with%20wind%20powers%2C%20warm%20autumn%20color' },
      { id: 'nagihikari-ova2', title: '凪光 OVA：冬日的约定', cover: 'https://readdy.ai/api/search-image?query=Anime%20winter%20scene%20snowy%20village%2C%20warm%20glowing%20windows%2C%20falling%20snow%2C%20cozy%20atmosphere&width=800&height=450&seq=nagi-rel-07&orientation=landscape' },
      { id: 'nagihikari-character-guide', title: '凪光 角色完全指南', cover: 'https://readdy.ai/api/search-image?query=Anime%20character%20lineup%20art%20six%20diverse%20characters%20fantasy%20series%2C%20clean%20anime%20style&width=800&height=450&seq=nagi-rel-05&orientation=landscape' },
    ],
  },
};

export const articleFaqs = [
  {
    question: '凪光第一季共有多少话？在哪里可以看？',
    answer: '凪光第一季共24话，已全部完结。您可以在凪光在线观看网站免费观看全部话数，支持PC端和手机端高清播放。',
  },
  {
    question: '凪光的声优阵容有哪些知名声优？',
    answer: '凪光系列聚集了日本一线声优阵容，包括松本健一（朝凪役）、佐藤美咲（光役）、田中翔太（炎真役）等，每位声优都为角色注入了鲜活的生命力。',
  },
  {
    question: '凪光适合什么年龄段的观众？',
    answer: '凪光的定位是少年向热血奇幻动画，适合12岁以上的观众。作品包含适度的战斗场面但不过度暴力，同时融入了友情、成长、守护等积极正面的主题。',
  },
];